import emojiRegex from 'emoji-regex';
import { CardTypes } from './enums';

export const Placeholders = {
    ArticleUrl: `@articleUrl`,
    LocalePlaceholder: `@locale`,
    LocalRepresentative: `@localRepresentative`,
    NumberOfAnswers: `@noOfAnswers`,
    PartnerName: '@partnerName',
    PartnerTwitterMention: '@partnerTwitterMention',
    PostalCodePlaceholder: `@postalCodePlaceholder`,
    PublisherName: '@publisherName',
    PublisherTwitterMention: '@publisherTwitterMention',
    TwitterMentionPlaceholder: `@twitterMentionPlaceholder`
};

function fillPartnerHtml(text, action) {
    return text
        .replace(
            new RegExp(Placeholders.PartnerName, 'g'),
            action.partner !== undefined
                ? '<span id="partnerName">' + action.partner.name + '</span>'
                : 'Speakable'
        )
        .replace(
            new RegExp(Placeholders.PartnerTwitterMention, 'g'),
            action.partner !== undefined
                ? '<span id="partnerName">' +
                      (action.partner.twitterMention !== undefined
                          ? '@' + action.partner.twitterMention
                          : action.partner.name) +
                      '</span>'
                : 'Speakable'
        );
}

function fillPartnerText(text, action) {
    return text
        .replace(
            new RegExp(Placeholders.PartnerName, 'g'),
            action.partner !== undefined ? action.partner.name : 'Speakable'
        )
        .replace(
            new RegExp(Placeholders.PartnerTwitterMention, 'g'),
            action.partner !== undefined
                ? action.partner.twitterMention !== undefined
                    ? '@' + action.partner.twitterMention
                    : action.partner.name
                : 'Speakable'
        );
}

function fillPublisherText(text, publisher) {
    return text
        .replace(
            new RegExp(Placeholders.PublisherName, 'g'),
            publisher.name || 'Speakable'
        )
        .replace(
            new RegExp(Placeholders.PublisherTwitterMention, 'g'),
            publisher.twitterMention || publisher.name || 'Speakable'
        );
}

function fillDynamicText(action, publisher) {
    if (action.title) {
        action.title = fillPartnerHtml(action.title, action);
    }
    if (action.description) {
        action.description = fillPartnerHtml(action.description, action);
    }
    if (action.text) {
        action.textOriginal = action.text;
        action.textRaw = fillPartnerText(action.text, action);
        action.text = fillPartnerHtml(action.text, action);
    }
    if (action.name) {
        action.name = fillPartnerHtml(action.name, action);
    }
    if (action.shortName) {
        action.shortName = fillPartnerHtml(action.shortName, action);
    }
    if (action.collectEmailText) {
        let collectEmailText = fillPartnerText(action.collectEmailText, action);
        collectEmailText = fillPublisherText(collectEmailText, publisher);
        action.collectEmailText = collectEmailText;

        action.collectEmailFor = {};
        action.collectEmailFor.publisherId =
            publisher &&
            publisher.id &&
            publisher.name &&
            collectEmailText.indexOf(publisher.name) > -1
                ? publisher.id
                : null;

        action.collectEmailFor.partnerId =
            action.partner &&
            action.partner.id &&
            action.partner.name &&
            collectEmailText.indexOf(action.partner.name) > -1
                ? action.partner.id
                : null;
    }
    return action;
}

function fillAction(action, publisher) {
    if (action.type === 'Tweet') {
        action.description = action.description || action.text;
    }
    return fillDynamicText(action, publisher);
}

export function fillCard(card, publisher) {
    card.heading = card.heading || '';
    card.subHeading = card.subHeading || '';
    card.actions = card.actions.map(action => fillAction(action, publisher));
    if (card.type === CardTypes.oneAction) {
        card.heading = fillPartnerHtml(
            card.heading || card.actions[0].title || '',
            card.actions[0]
        );
        card.localRepresentativeState = card.actions[0].representativeSearch;

        const subHeadingDefault = !card.representativeSearch
            ? ''
            : '@localRepresentative';
        card.subHeading = fillPartnerHtml(
            card.subHeading || card.actions[0].description || subHeadingDefault,
            card.actions[0]
        );
    }

    if (card.type === CardTypes.actionChoice) {
        card.heading = fillPartnerHtml(card.heading, card);
        card.subHeading = fillPartnerHtml(card.subHeading, card);
    }

    if (!!card.partner) {
        if (card.heading) {
            card.heading = fillPartnerHtml(card.heading, card);
        }
        if (card.subHeading) {
            card.subHeading = fillPartnerHtml(card.subHeading, card);
        }
    } else {
        if (card.heading && card.actions[0].partner) {
            card.heading = fillPartnerHtml(card.heading, card.actions[0]);
        }
        if (card.subHeading && card.actions[0].partner) {
            card.subHeading = fillPartnerHtml(card.subHeading, card.actions[0]);
        }
    }

    if (card.heading && publisher) {
        card.heading = fillPublisherText(card.heading, publisher);
    }
    if (card.subHeading && publisher) {
        card.subHeading = fillPublisherText(card.subHeading, publisher);
    }

    if (card.type === CardTypes.targetedMultiAction) {
        if (card.recipientPictureId) {
            card.actions.forEach(
                action =>
                    (action.recipientPictureId =
                        action.recipientPictureId || card.recipientPictureId)
            );
        }

        if (card.heading && !card.partner && !card.actions[0].partner) {
            card.heading = fillPartnerHtml(card.heading, {});
        }
        if (card.subHeading && !card.partner && !card.actions[0].partner) {
            card.subHeading = fillPartnerHtml(card.subHeading, {});
        }
    }
    return card;
}

export const formatEmoji = (text = '') => {
    const regex = emojiRegex();
    const emojiMatches = text.match(regex);
    const textMatches = text.match(/[a-z0-9]/gi);
    let htmlString = '';
    if (emojiMatches && !textMatches) {
        emojiMatches.forEach(match => {
            htmlString += `<span class="emoji">${match}</span>`;
        });
    } else {
        htmlString += text;
    }
    return htmlString;
};
